import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  selectActiveReferralValue,
  selectActiveReferrals,
  selectProjectedCloses,
  selectCloses,
  selectCloseValue,
  selectBrokerMetPercentage,
  selectMarketMetPercentage,
  selectBrokerOfferPercentage,
  selectMarketOfferPercentage,
  selectBrokerContractPercentage,
  selectMarketContractPercentage,
  selectBrokerClosedPercentage,
  selectMarketClosedPercentage,
  selectBrokerPerformanceLoading
} from 'broker/selectors/broker_performance'

import { fetchBrokerPerformanceStats } from 'broker/redux/broker_performance'
import { wholeDollars, wholeInteger, percentToHundredths, formatOrDash } from 'broker/util/helper'

import Card from 'broker/views/components/Card'
import CardLightHeading from 'broker/views/components/CardLightHeading'
import CardContentRow from 'broker/views/components/CardContentRow'
import RawCardSection from 'broker/views/components/CardSection'
import CardFlexingContentRow from 'broker/views/components/CardFlexingContentRow'
import RawCardDataPoint from 'broker/views/components/CardDataPoint'
import CardRow from 'broker/views/components/CardRow'
import SLTitleSmall from 'broker/views/components/SkeletonLoader/SLTitleSmall'

const CardDataPoint = connect(createStructuredSelector({
  loading: selectBrokerPerformanceLoading
}))(RawCardDataPoint)

const CardSection = connect(createStructuredSelector({
  loading: selectBrokerPerformanceLoading
}))(RawCardSection)

const TitleRow = () => (
  <div>
    <CardLightHeading title>Brokerage Performance</CardLightHeading>
    <CardLightHeading>&nbsp;&nbsp;(showing all time)</CardLightHeading>
  </div>
)

class BrokerPerformanceCard extends Component {
  componentDidMount() {
    this.props.fetchBrokerPerformanceStats()
  }

  render() {
    const {
      loading, activeReferralValue, activeReferrals, projectedCloses, closes, closeValue,
      brokerMetPercentage, marketMetPercentage, brokerOfferPercentage, marketOfferPercentage,
      brokerContractPercentage, marketContractPercentage, brokerClosedPercentage, marketClosedPercentage
    } = this.props

    return (
      <Card>
        <CardContentRow>
          { loading ? <SLTitleSmall/> : <TitleRow/>}
          <div>
            {/* filters button goes here */}
          </div>
        </CardContentRow>
        <CardSection title="Totals">
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Active Referral Value *"
                value={formatOrDash(activeReferralValue, wholeDollars, { prefix: '$' })}
              />
            </CardFlexingContentRow>
          </CardRow>
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Active Referrals"
                value={formatOrDash(activeReferrals, wholeInteger)}
              />
              <CardDataPoint
                title="Projected Closes"
                value={formatOrDash(projectedCloses, wholeInteger)}
              />
            </CardFlexingContentRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Closes"
                value={formatOrDash(closes, wholeInteger)}
              />
              <CardDataPoint
                title="Close Value"
                value={formatOrDash(closeValue, wholeDollars, { prefix: '$' })}
              />
            </CardFlexingContentRow>
          </CardRow>
        </CardSection>
        <CardSection title="Pipeline" subtitle="(compared to agents in your markets)">
          <CardRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Met/House Hunted"
                value={formatOrDash(brokerMetPercentage, percentToHundredths, { suffix: '%' })}
                compareValue={formatOrDash(marketMetPercentage, percentToHundredths, { suffix: '%' })}
              />
              <CardDataPoint
                title="Made Offers"
                value={formatOrDash(brokerOfferPercentage, percentToHundredths, { suffix: '%' })}
                compareValue={formatOrDash(marketOfferPercentage, percentToHundredths, { suffix: '%' })}
              />
            </CardFlexingContentRow>
            <CardFlexingContentRow>
              <CardDataPoint
                title="Under Contract"
                value={formatOrDash(brokerContractPercentage, percentToHundredths, { suffix: '%' })}
                compareValue={formatOrDash(marketContractPercentage, percentToHundredths, { suffix: '%' })}
              />
              <CardDataPoint
                title="Closed"
                value={formatOrDash(brokerClosedPercentage, percentToHundredths, { suffix: '%' })}
                compareValue={formatOrDash(marketClosedPercentage, percentToHundredths, { suffix: '%' })}
              />
            </CardFlexingContentRow>
          </CardRow>
        </CardSection>
      </Card>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  activeReferralValue: selectActiveReferralValue,
  activeReferrals: selectActiveReferrals,
  projectedCloses: selectProjectedCloses,
  closes: selectCloses,
  closeValue: selectCloseValue,
  brokerMetPercentage: selectBrokerMetPercentage,
  marketMetPercentage: selectMarketMetPercentage,
  brokerOfferPercentage: selectBrokerOfferPercentage,
  marketOfferPercentage: selectMarketOfferPercentage,
  brokerContractPercentage: selectBrokerContractPercentage,
  marketContractPercentage: selectMarketContractPercentage,
  brokerClosedPercentage: selectBrokerClosedPercentage,
  marketClosedPercentage: selectMarketClosedPercentage,
  loading: selectBrokerPerformanceLoading
})

const mapDispatchToProps = dispatch => ({
  fetchBrokerPerformanceStats: () => dispatch(fetchBrokerPerformanceStats())
})

export default connect(mapStateToProps, mapDispatchToProps)(BrokerPerformanceCard)
